import type { Routes } from 'react-resource-router';

import { assistantRoutes } from './assistant';
import { catalogRoutes } from './catalog';
import { cypherExplorerRoutes } from './cypher-explorer';
import { graphExplorerRoutes } from './graph-explorer';
import { graphClawHubRoutes } from './graphclaw-hub';
import { route as homeRoute } from './home';
import { inferenceRoutes } from './inference';
import { inferredProjectsRoutes } from './inferred-projects';
import { labsRoutes } from './labs';
import { queryBuilderRoutes } from './query-builder';
import { simpleGraphExplorerRoutes } from './simple-graph-explorer';
import { visualiserRoutes } from './visualiser';

export const routes: Routes = [
	homeRoute,
	...catalogRoutes,
	...labsRoutes,
	...assistantRoutes,
	...visualiserRoutes,
	...queryBuilderRoutes,
	...graphExplorerRoutes,
	...cypherExplorerRoutes,
	...simpleGraphExplorerRoutes,
	...inferenceRoutes,
	...graphClawHubRoutes,
] as const;

// Workstreams (/workstreams and the legacy /inferred-projects redirect) is hidden while its
// backing GraphQL field, graphInference_inferredProjectMe, is retired. The route and page code
// stay in ./inferred-projects; move these back into `routes` to re-enable the page.
export const hiddenRoutes: Routes = [...inferredProjectsRoutes] as const;
